import { BaseIcon } from '../BaseIcon';
import type { SizedIconProps } from '../BaseIcon';
import { IconSize } from '../../../../enums';

type NotQuotingIconProps = Omit<SizedIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const NotQuotingIcon = ({ strokeWidth, size = IconSize.Standard, ...props }: NotQuotingIconProps) => {
  if (size === IconSize.Mini) {
    return (
      <BaseIcon width="10" height="14" viewBox="0 0 10 14" fill="none" strokeWidth={strokeWidth} {...props}>
        <g clipPath="url(#clip0_8641_51576)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.58579 1L1 1L1 13H9V4.41421L5.58579 1ZM5.58579 0C5.851 0 6.10536 0.105357 6.29289 0.292893L9.70711 3.70711C9.89464 3.89464 10 4.149 10 4.41421V13C10 13.5523 9.55228 14 9 14H1C0.447715 14 0 13.5523 0 13V1C0 0.447715 0.447715 0 1 0H5.58579Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.14645 5.14645C3.34171 4.95118 3.65829 4.95118 3.85355 5.14645L6.85355 8.14645C7.04882 8.34171 7.04882 8.65829 6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355L3.14645 5.85355C2.95118 5.65829 2.95118 5.34171 3.14645 5.14645Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.85355 5.14645C7.04882 5.34171 7.04882 5.65829 6.85355 5.85355L3.85355 8.85355C3.65829 9.04882 3.34171 9.04882 3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645L6.14645 5.14645C6.34171 4.95118 6.65829 4.95118 6.85355 5.14645Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_8641_51576">
            <rect width="10" height="14" fill="white" />
          </clipPath>
        </defs>
      </BaseIcon>
    );
  }
  return (
    <BaseIcon width="14" height="18" viewBox="0 0 14 18" fill="none" strokeWidth={strokeWidth} {...props}>
      <g clipPath="url(#clip0_8641_51591)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 1C0 0.447715 0.447715 0 1 0H9C9.26522 0 9.51957 0.105357 9.70711 0.292893L13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V17C14 17.5523 13.5523 18 13 18H1C0.447715 18 0 17.5523 0 17V1ZM2 2V16H12V5.41421L8.58579 2H2Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.28429 6.3016C4.67001 5.90633 5.30313 5.89858 5.6984 6.28429L9.79752 10.2843C10.1928 10.67 10.2005 11.3031 9.81483 11.6984C9.42911 12.0937 8.796 12.1014 8.40072 11.7157L4.3016 7.71571C3.90633 7.32999 3.89858 6.69687 4.28429 6.3016Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.74796 6.23473C10.1432 6.62045 10.151 7.25357 9.76527 7.64884L5.76527 11.748C5.37955 12.1432 4.74643 12.151 4.35116 11.7653C3.95589 11.3796 3.94814 10.7464 4.33385 10.3512L8.33385 6.25204C8.71957 5.85677 9.35269 5.84902 9.74796 6.23473Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_8641_51591">
          <rect width="14" height="18" fill="white" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

NotQuotingIcon.displayName = 'NotQuotingIcon';
